let settings = window.__PRELOADED_STATE__ && window.__PRELOADED_STATE__.settings || {};

export default settings;